import { c as _c } from "react/compiler-runtime";
import { ApplicationTypeEnum } from "@lib/api/enums";
import usePartnerContext from "@lib/hooks/usePartnerContext";
import { ApplicationFormValues } from "@lib/mapApplicationData/types";
import { FC } from "react";
import { FormStepComponent } from "../FormSteps/FormSteps";
import AppAccessLeadWall from "./AppAccessLeadWall";
import ApplicationLeadWall from "./ApplicationLeadWall";

// The application type is only known once the user has passed the zero step, so
// the branch cannot be resolved when the steps are registered. Partner funnels
// stay on the old wall: they have no app-access confirmation page of their own.
export const usesAppAccessLeadWall = (applicationType: ApplicationFormValues["applicationType"] | undefined, hasPartner: boolean) => !hasPartner && applicationType === ApplicationTypeEnum.BUY_WITH_SAVINGS;
const FinalLeadWall: FC<FormStepComponent<ApplicationFormValues>> = props => {
  const $ = _c(4);
  const {
    partner
  } = usePartnerContext();
  if (usesAppAccessLeadWall(props.value.applicationType, !!partner)) {
    let t0;
    if ($[0] !== props) {
      t0 = <AppAccessLeadWall {...props} />;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let t0;
  if ($[2] !== props) {
    t0 = <ApplicationLeadWall {...props} />;
    $[2] = props;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};
export default FinalLeadWall;